import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSignOut } from "react-auth-kit";
import { sendApiRequest } from "../../services/Base/base-service";
import { clearSecureStorage, clearUserContext } from "../../services/helpers";

import UserContext from "../../store/user-context";
import { Spinner } from "design-react-kit";

const ConfirmEmail = () => {
  const location = useLocation();
  const locationArray = location.search.replace("?", "").split("&");

  const paramsArray = [];
  locationArray.map((item) => paramsArray.push(item.split(/=(.*)/s)));

  const userContext = useContext(UserContext);
  const signOut = useSignOut();

  let token = "";
  let email = "";
  let activationType = "";

  paramsArray.forEach((item) => {
    if (item[0] === "token") {
      token = item[1];
    } else if (item[0] === "email") {
      email = item[1];
    } else if (item[0] === "activationType") {
      activationType = item[1];
    }
  });

  const navigate = useNavigate();

  useEffect(() => {
    signOut();
    clearSecureStorage();
    clearUserContext(userContext);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    sendApiRequest(
      "Activation/ConfirmEmail",
      "POST",
      false,
      { token: token, email: email },
      null,
      null,
      navigate,
      null
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          navigate("/errors");
        } else {
          navigate(
            `/changePassword?userId=${response.data.userId}&token=${response.data.token}&activationType=${activationType}`
          );
        }
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Spinner double active />;
};

export default ConfirmEmail;
